var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6668 13.9999L8.00013 10.6666L3.3335 13.9999V3.33332C3.3335 2.9797 3.47397 2.64057 3.72402 2.39052C3.97406 2.14047 4.3132 2 4.66682 2H11.3334C11.6871 2 12.0262 2.14047 12.2762 2.39052C12.5263 2.64057 12.6668 2.9797 12.6668 3.33332V13.9999Z",
    stroke: "#1A4F73",
    strokeWidth: 1.33332,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBookmark);
export default __webpack_public_path__ + "static/media/icon_bookmark.8f661a89f0dc99031138fa2e80b8d1e1.svg";
export { ForwardRef as ReactComponent };